import axios from 'axios';

const axiosInstance = () => axios.create({
  baseURL: `${window.location.origin}/local/ajax/order`,
});

const methods = {
  getOrders: (formData) => axiosInstance().get('/getOrders.php', formData),
};

export default methods;
